export const msalConfig = {
  auth: {
    clientId: process.env.REACT_APP_MSAL_CONFIG_CLIENT_ID,
    authority: process.env.REACT_APP_MSAL_CONFIG_AUTHORITY,
    redirectUri: process.env.REACT_APP_MSAL_CONFIG_REDIRECT_URI,
    // postLogoutRedirectUri: "/", // Indique la page de redirection après la déconnexion
    navigateToLoginRequestUrl: false, // Si "true", redirige vers la page d'origine après la connexion
    validateAuthority: true,
  },
  cache: {
    cacheLocation: "localStorage",
    storeAuthStateInCookie: false,
  },
};

export const loginRequest = {
  scopes: ["openid", "profile"],
};
